import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'hexColor',
  standalone: false,
})
export class HexColorPipe implements PipeTransform {
  transform(inputString: string | null | undefined): string {
    if (!inputString) return '#dddddd';

    let hash = 0;
    for (let i = 0; i < inputString.length; i++) {
      hash = inputString.charCodeAt(i) + ((hash << 5) - hash);
    }

    const hue = hash % 360;
    const saturation = 60 + (hash % 20); // 60–80%
    const lightness = 70 + (hash % 10); // 70–80%

    return `hsl(${hue}, ${saturation}%, ${lightness}%)`;
  }
}
